module.exports = __webpack_public_path__ + "img/img_segnaposto_home_profilo.0fe8cb3b.png";